import React from 'react'
import PropTypes from 'prop-types'
import League from './league'

function LeaguesPlugin(props) {
  const leaguesList = () => {
    return props.leagues.map((league, index) => {
      return <League league={league} key={index} token={props.token} locationId={props.locationId} />
    })
  }

  return <div className='leagues-content'>
    <div className='leagues-content__title'>LEAGUES REGISTRATION</div>
    <div className='row leagues-list'>
      {leaguesList()}
    </div>
  </div>
}

LeaguesPlugin.propTypes = {
  leagues: PropTypes.array.isRequired,
  token: PropTypes.string.isRequired,
  locationId: PropTypes.number.isRequired,
}

export default LeaguesPlugin
